import { RootState } from 'store';
import { useSelector } from 'react-redux';

export function WelcomeHero() {
  const isDarkMode = useSelector((state: RootState) => state.theme.isDarkMode);

  return (
    <div className="space-y-4 md:space-y-8">
      <span className="flex items-center gap-2">
        <img
          src={isDarkMode ? '/podcast-dark.png' : '/podcast-icon.png'}
          className="max-h-[120px] md:max-h-[146px] h-full"
          alt="Podcast Generator"
        />
      </span>
      <div className="flex flex-col lg:gap-4">
        <h1 className="text-2xl md:text-5xl font-medium text-text-primary lg:leading-[60px]">
          Welcome to <br className="hidden md:block" /> Podcast{' '}
          <br className="hidden md:block" /> Generator
        </h1>
        <p className="text-sm lg:text-xl font-normal text-text-primary md:w-[400px] mb-6 lg:mb-0">
          Discover the ultimate AI-powered podcast generator that helps you
          create high-quality audio content effortlessly. From scripting to
          editing, our tool streamlines every step.
        </p>
      </div>
    </div>
  );
}
